import { Star } from 'lucide-react';
import { TESTIMONIALS } from '../data';

export function TestimonialSection() {
  return (
    <section className="bg-white">
      <div className="mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="rounded-2xl bg-brand-50 px-6 py-10 sm:rounded-3xl sm:px-10 sm:py-12 lg:px-14 lg:py-14">
          <p className="text-xs font-semibold uppercase tracking-[0.18em] text-brand-600 sm:text-sm">
            Parent Reviews
          </p>

          <h2 className="mt-5 max-w-xl text-3xl font-semibold leading-[1.1] tracking-tight text-slate-900 sm:text-4xl lg:text-5xl">
            What parents said
            <br className="hidden sm:block" />{' '}
            after the first summer.
          </h2>

          <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {TESTIMONIALS.map((testimonial) => (
              <div
                key={testimonial.initials}
                className="flex flex-col rounded-2xl bg-white p-7 shadow-sm ring-1 ring-slate-200/60"
              >
                <div className="flex gap-1">
                  {Array.from({ length: testimonial.stars }).map((_, index) => (
                    <Star
                      key={index}
                      className="size-4 fill-amber-400 text-amber-400"
                      aria-hidden="true"
                    />
                  ))}
                </div>

                <p className="mt-4 flex-1 text-base leading-relaxed text-slate-700">
                  &ldquo;{testimonial.quote}&rdquo;
                </p>

                <div className="mt-6 flex items-center gap-3">
                  <span className="flex size-10 shrink-0 items-center justify-center rounded-full bg-brand-100 text-xs font-semibold text-brand-700">
                    {testimonial.initials}
                  </span>
                  <div>
                    <p className="text-sm font-semibold text-slate-900">{testimonial.name}</p>
                    <p className="text-xs text-slate-500">{testimonial.subtitle}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}